import React from "react";

const PhoneNumber = ({number, isLinked, className}) => {
    if (!number) return null;

    number = number.toString().replace(/[^0-9+]+/g, '').replace(/\s+/, '');
    let formatted_number;

    if (number.indexOf("7") === 0 && (number.indexOf("4") === 1 || number.indexOf("9") === 1)) {
        formatted_number = number.replace(/([0-9])([0-9]{3})([0-9]{3})([0-9]{2})([0-9]{2})/g, "+$1 ($2) $3-$4-$5")
    } else if (number.indexOf("8") === 0){
        formatted_number = number.replace(/([0-9])([0-9]{3})([0-9]{3})([0-9]{2})([0-9]{2})/g, "$1 $2 $3-$4-$5")
    }
    
    return isLinked ? (<a href={`tel:${number}`} className={className}>{formatted_number ? formatted_number : number}</a>) :
        (<span className={className}>{formatted_number ? formatted_number : number}</span>)
};

PhoneNumber.defaultProps = {
    isLinked: false,
};

export default PhoneNumber


// WEBPACK FOOTER //
// ./src/components/NumberPrettifier/NumberPrettifier.jsx